import React, { useEffect, Fragment } from 'react';
import IsLoadingBar from '../isLoading';
import { useMsal } from "../../Auth/msal-context";
import {Card, Accordion, Button, OverlayTrigger, Tooltip, Form } from 'react-bootstrap';
import moment from 'moment';

import './Manager.scss';

const Manager = (props) => {
    const { getToken } = useMsal();
    const [isLoading, setIsLoading] = React.useState(true);  
    const [directReports, setDirectReports] = React.useState([]);
    const [userCases, setUserCases] = React.useState([]);
    const [selectedUserCases, setSelectedUserCases] = React.useState([]);   
    const [cerebroIsOpen, setCerebroIsOpen] = React.useState(false);
    const [openedInFetchPro, SetOpenedInFetchPro] = React.useState([]);
    const [caseGroup, setCaseGroup] = React.useState([]);    
    const [activeStatusCode, setActiveStatusCode] = React.useState(null); 

    useEffect(() => {
        getDirectReports();
        setCerebroIsOpen((sessionStorage.getItem("cerebroSession") !== null && sessionStorage.getItem("cerebroSession") !== undefined) ? true : false);
    },[]);

    const getDirectReports = async () => {
        let accessToken = await getToken();
        fetch('/api/getDirectReports', {
            method: "GET",
            headers: {
                "content-type" : "application/json",
                Authorization : "Bearer " + accessToken,
            }
        })
        .then(response => response.json())
        .then(data => {
            if(data){
                setDirectReports(data.value.sort((a,b) => a.surname.localeCompare(b.surname)));
                let userEmails = new Set();
                data.value.map(el => {
                    userEmails.add(el.mail);
                });
                getCases(userEmails);
            } 
            setIsLoading(false);
        });

    };

    const getCases = async (userEmails) => {
        let accessToken = await getToken();
        fetch(`/api/getCasesByUser`, {
            method : "GET",
            headers: {
                "useremails" : `'${userEmails.join("','")}'`,
                'Authorization': "Bearer " + accessToken, 
            }
        })
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => {
            setUserCases(data);
            setIsLoading(false);
            let caseIdArr = [];
            let caseGroup = new Set();
            caseGroup.add('Waiting for Ceridian');
            caseGroup.add('In Progress');
            caseGroup.add('Waiting for Customer');
            for(let i = 0; i < data.length; i++){
                caseIdArr.push(data[i].incidentid);
                caseGroup.add(data[i].statuscode);
            }

            setCaseGroup(Array.from(caseGroup));
            hasAnalystUsedPro(caseIdArr);

        }).catch((error) => {
            window.apiError(error);
        });
    };

    const getUserCases = (email) => {
        setSelectedUserCases([]);
        let userOpenCases = userCases.filter(el => el.internalemailaddress === email);
        setSelectedUserCases(userOpenCases.sort((a,b) => new Date(b.createdon) - new Date(a.createdon)));
    };

    const caseCount = (email) => {
        let userOpenCases = userCases.filter(el => el.internalemailaddress === email);
        return userOpenCases.length;
    };

    const initQuickView = (link,title,incidentid,isCerebro) => {  
        if((sessionStorage.getItem("cerebroSession") && sessionStorage.getItem("cerebroSession") !== undefined) || isCerebro !== true){
            props.initQuickView(link,title);
        } else {
            window.history.pushState(null,null, `/q?cerebro&CRMId=${incidentid}`);
            props.initQuickView(link,title);
        }       
    };

    const hasAnalystUsedPro = async (caseIdArr) => {

        let data = {
            cases : `'${caseIdArr.join("','")}'`
        };
        console.log("hasAnalystUsedPro");
        let accessToken = await getToken();
        fetch('/api/hasAnalystOpenedCaseInProMultiCases', {
            method : "POST",
            headers : {
                "content-type" : "application/json",
                Authorization : "Bearer " + accessToken,
                withCredentials : true,
                crossDomain: true
            },
            body : JSON.stringify(data)          
        }).then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                };
            }
            return response.json();
        }).then(data => { 
            let openedInFetchPro =  new Set();
            data.map(item => {
                openedInFetchPro.add(item.cerebroCaseNumber);
            });
            SetOpenedInFetchPro(Array.from(openedInFetchPro));
        }).catch((error) => {
            window.apiError(error);
        });
    };

    if(isLoading){
        return  <IsLoadingBar />;
    }

    return (
        <div id="manager-pane">
             <div className="pl-3 mb-0">
                Your Direct Reports
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip>
                            Non Resolved Cases
                        </Tooltip>
                    }>
                    <i className="far fa-question-circle tooltip-icon"></i>
                </OverlayTrigger>  
            </div>

            <Accordion defaultActiveKey="0">
                {directReports.map((items,index) => 
                    <Card key={index} style={items.displayName.indexOf("(P") > -1 ? {display : "none"} : {}}>
                        <Accordion.Toggle as={Card.Header} eventKey={index.toString()} onClick={() => getUserCases(items.mail)}>
                            <div className="case-box">                                    
                                <h6 className="mb-0">{items.displayName}</h6>
                                <p><strong>Role: {items.jobTitle}</strong></p>
                                <p><strong>Open Cases: {caseCount(items.mail)}</strong></p>                            
                            </div>
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey={index.toString()}>
                            <Accordion activeKey={activeStatusCode} defaultActiveKey="0">
                                {caseGroup.map((statusCode, statusIndex) =>                    
                                    <div key={statusIndex}>
                                        <Button variant="link" className="text-left pl-3 ml-2 text-muted" style={{ fontSize : 12}} onClick={() => setActiveStatusCode(statusIndex.toString() === activeStatusCode ? "-1" : statusIndex.toString()) }>{statusCode} <strong>{` (${selectedUserCases.filter(el => el.statuscode === statusCode).length}) `}</strong> <span>{statusIndex.toString() === activeStatusCode ? " -" : " +"}</span>
                                        </Button>
                                        <Accordion.Collapse eventKey={statusIndex.toString()}>
                                        <div>       
                                        <Accordion defaultActiveKey="0"> 
                                            {selectedUserCases.filter(el => el.statuscode === statusCode).map((items,index) => 
                                                <div className="details" key={index}>
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip>
                                                        Need help? Launch Fetch Pro
                                                        </Tooltip>
                                                    }>
                                                <Button className="lightbulb" onClick={() => initQuickView(`D365/QuickView/${items.incidentid}`,items.title,items.incidentid,true)}><i className="far fa-lightbulb"></i></Button>
                                                </OverlayTrigger>   

                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip>
                                                        Open in Quick View
                                                        </Tooltip>
                                                    }>
                                                    <Button className="quickview"  onClick={() => initQuickView(`D365/QuickView/${items.incidentid}`,items.title,items.incidentid)} >
                                                        <i className="fas fa-eye"></i>
                                                    </Button>
                                                </OverlayTrigger>
                                                    
                                                    <span><strong>Case Title : </strong>{items.title}</span>
                                                    <span><strong>Client Namespace : </strong>{items.ClientNamespace}
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                See namespace details
                                                            </Tooltip>
                                                        }>
                                                        <Button variant="link" className="p-0 m-0 namespace_connector" onClick={() => props.selectedAccount([items.ClientNamespace])}><i className="fas fa-arrow-circle-right"></i></Button>
                                                    </OverlayTrigger>
                                                    </span>
                                                    
                                                    <span><strong>Case Number : </strong>
                                                        <a href={`https://crmreports.ceridian.net/Dynamics365/crm.html#/d365/case/${items.incidentid}`} target="_blank">{items.ticketnumber}</a>
                                                        {openedInFetchPro.includes(items.ticketnumber) && (
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={
                                                                <Tooltip>
                                                                    Analyst has opened in Fetch Pro
                                                                </Tooltip>
                                                            }>
                                                            <span className="analyst_check"></span> 
                                                        </OverlayTrigger>
                                                        )}
                                                    </span>
                                                    <span><strong>Created Date : </strong>{moment(items.createdon).format("YYYY-MM-DD")}</span>
                                                    <span><strong>Severity:</strong> {items.severitycode}</span>
                                                    <span><strong>Status:</strong> {items.statuscode}</span>
                                                    <span><strong>Category:</strong> {items.cer_category}</span>
                                                    <span><strong>First Response:</strong> {items.firstresponsesent ? "Yes" : "No"}</span>
                                                    <span><strong>Resolution Time:</strong> {items.TimeRemainingResolution} days</span>
                                                    
                                                    
                                                </div>
                                            )}
                                        </Accordion>
                                        </div>
                                        </Accordion.Collapse>
                                    </div>  
                                )}
                            </Accordion>                                    
                        </Accordion.Collapse>
                        <div className="morph-border"></div>
                    </Card>
                )}
            </Accordion>
            
            {directReports.length === 0 && (
                <Fragment>
                    <p className="pl-3" style={{fontSize: "12px"}}>You don't have any direct reports</p>
                    <i className="fas fa-users no-direct"></i>
                </Fragment>
                
            )}
        </div>
   );

}

export default Manager;
